const state = {
  userInfo: null,
  token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('token', token)
  },
  SET_USER: (state, payload) => {
    state.userInfo = payload
  },
  LOGOUT: (state) => {
    state.token = ''
    localStorage.removeItem('token')
    state.userInfo = null
  },
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
